<template>
    <div class="rr-builder-loader uk-overlay-default uk-position-cover" v-show="isLoading">
       <slot> </slot>
    </div>
</template>

<style lang="less">
    @import (reference) "~less/app";
    @import "~rubinred/content/less/rubinred-builder";

    /* loader */
    .rr-builder-loader {
        background-color: fade(@builder-color-white, 80%);
    }
</style>

<script>
  export default {
    data() {
      return {
        isLoading: false
      }
    },

    created() {
      this.$root.$on('loader-handler', this.loaderHandler);
    },

    methods: {
        loaderHandler(loading) {
            this.isLoading = loading;
        }
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/content/assets/js/components/BuilderLoader.vue